import { Link } from 'expo-router';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { ProductListTile } from '../product-list-tile';

import type { ItemType, TileSizeType } from './types';

export type SectionListItemProps = {
  tileSize: TileSizeType;
  style?: ViewProps['style'];
  item: ItemType;
};

export const SectionListItem = ({ tileSize, item, style }: SectionListItemProps) => {
  return (
    <View style={[containerStyles.container, style]}>
      <Link href={item.href} asChild>
        <ProductListTile
          size={tileSize}
          image={item.image}
          title={item.title}
          description={item.description}
          badge={item.badge}
          isAvailable={item.isAvailable}
        />
      </Link>
    </View>
  );
};

const containerStyles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flexGrow: 1,
    flexShrink: 1,
  },
});
